// @ts-nocheck
/* eslint-disable spire/export-styles */
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import * as React from "react";

// Bunzl Custom Code
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import constants from "@toolkit/constants";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps;

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => {
    /* Bunzl Custom Code - Start */
    const currentPage = useCurrentPage();
    const showFlyout = constants.pageType.productCompare !== currentPage.type;
    /* Bunzl Custom Code - End */
    return (
        <>
            <AddToListModal />
            <ShareListModal />
            <ManageShareListModal />
            <ShareListDetailModal />
            {/* Bunzl Custom Code */}
            {showFlyout && <ProductCompareFlyOut />}
            <ProductSelectorVariantModal
                skipInventoryValidation={skipInventoryValidation}
                skipProductPrice={skipProductPrice}
            />
            <ProductDeliveryScheduleModal />
        </>
    );
};

export default Modals;
